import { useCallback } from 'react';
import { useSearchParams } from 'react-router';
import authTokenUtil from './authTokenUtil';
import { useAppDispatch } from '../app/redux/useAppSelector';
import {
  ACTION_SIGNUP_FINISH,
  CATEGORY_SITE,
  LAYER,
} from '../constants/analytics';
import { SUBJECT_ORG_ONBOARDING } from '../constants/onboarding';
import { OnboardingActions } from '../onboarding/onboardingSlice';
import { track } from '../utils/analytics';
import safeParseUrl from '../utils/url/safeParseUrl';

const usePostLoginHandler = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { host } = window.__slab.PUBLIC_ORG;

  return useCallback(
    (authToken: string) => {
      authTokenUtil.set(authToken);

      if (searchParams.get('firstLogin')) {
        dispatch(
          OnboardingActions.setOnboardingData({
            subject: SUBJECT_ORG_ONBOARDING,
            step: 0,
          }),
        );

        // Needed to track Google Adwords conversions
        track(ACTION_SIGNUP_FINISH, {
          category: CATEGORY_SITE,
          label: host,
          platform: searchParams.get('platform') || 'email',
          layer: LAYER,
        });
      }

      const redirectUrl = safeParseUrl(
        searchParams.get('redirect') ?? '/',
        window.location.origin,
      );

      // We need to do a full refresh so that the apollo client gets
      // the new auth token when it sets up the socket for subscriptions
      window.location.href = redirectUrl
        ? `${redirectUrl.pathname}${redirectUrl.search}`
        : '/';
    },
    [dispatch, host, searchParams],
  );
};

export default usePostLoginHandler;
